var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"overline text-center pt-8",style:(_vm.color)},[_c('v-icon',{style:(_vm.color),attrs:{"small":""}},[_vm._v(_vm._s(_vm.icono))]),_vm._v(" "+_vm._s(_vm.textoSeparador)+" ")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }